import { useState, useEffect } from 'react';
import { useProfile } from './useProfile';

export function useQRCode() {
  const [qrCodeData, setQRCodeData] = useState<string | null>(null);
  const { profile } = useProfile();

  useEffect(() => {
    // Si un QR code existe déjà dans le profil, on l'utilise
    if (profile.qrCodeUrl) {
      setQRCodeData(profile.qrCodeUrl);
    }
  }, [profile.qrCodeUrl]);

  const updateQRCode = (newQRCode: string) => {
    setQRCodeData(newQRCode);
  };

  return {
    qrCodeData,
    updateQRCode,
    hasQRCode: Boolean(qrCodeData || profile.qrCodeUrl)
  };
}